export default __webpack_public_path__ + "media/flags/tj-dc1a2e8e.svg";